// extracted by mini-css-extract-plugin
export default {"fabList":"fabList_fabList__sh4fn"};